import { render } from "./OCases.vue?vue&type=template&id=4b298226&scoped=true"
import script from "./OCases.vue?vue&type=script&lang=js"
export * from "./OCases.vue?vue&type=script&lang=js"

import "./OCases.vue?vue&type=style&index=0&id=4b298226&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b298226"]])

export default __exports__